/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { Group, ScrollArea } from "@mantine/core";
import { post } from "aws-amplify/api";

const stripePromise = loadStripe(process.env.STRIPE_PUBLIC_KEY || "");

function StripeCheckout() {
  const location = useLocation();
  const checkoutState = location.state;

  if (checkoutState == null) {
    window.location.href = "/plans";
  }

  const fetchClientSecret = useCallback(async () => {
    const postStripeBackend = post({
      apiName: "StripeBackend",
      path: `/stripe/create-checkout-session`,
      options: {
        body: {
          ...checkoutState,
        },
      },
    });
    try {
      const resp = await postStripeBackend.response;
      const payload: any = await resp.body.json();
      return payload.clientSecret;
    } catch (error) {
      console.error(error);
      return null;
    }
  }, [checkoutState]);

  const options = { fetchClientSecret };

  return (
    <ScrollArea h="calc(100vh - 60px)">
      <Group
        id="checkout"
        pt="md"
        style={{
          width: "100%",
          height: "100vh", // Make sure the Group spans the entire viewport height
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgb(0, 53, 84)",
        }}
      >
        <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
          <EmbeddedCheckout className="stripe-checkout" />
        </EmbeddedCheckoutProvider>
      </Group>
    </ScrollArea>
  );
}

export default StripeCheckout;
